import { useEffect } from 'react'
import { trackProductBrowse } from 'modules/listrak/utils'
import { useListrakReady } from '../useListrakReady'
import { useStoreView } from 'hooks/useStoreView'

export const useListrakProductBrowse = ({ sku }: { sku: string }) => {
  const { isLoaded } = useListrakReady()
  const { isSofiaAndGrace } = useStoreView()

  useEffect(() => {
    if (isLoaded && sku && isSofiaAndGrace) {
      trackProductBrowse([sku])
    }
  }, [isLoaded, sku, isSofiaAndGrace])

  return null
}
